import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-about" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Freeside"),
          _createElementVNode("span", { class: "blink" }, " - Why wait?", -1)
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, [
            _createTextVNode("Build 19840701, "),
            _createElementVNode("span", { class: "japanese" }, "営団"),
            _createTextVNode("Freeside")
          ], -1)),
          _createElementVNode("div", null, _toDisplayString(_ctx.slogan), 1)
        ]),
        _: 1,
        __: [1]
      })
    ]),
    _: 1
  }))
}